module.exports = __webpack_public_path__ + "303c59fd03e76d08e2b574bd16163dbb-orange-shovel2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/home/assets/orange-shovel2.png
// module id = 179
// module chunks = 0